import React, { useEffect, useState, useCallback } from "react";
import { useUser } from "../../../context/UserContext";
import "./Adminusercontrol.css";
import AdminNav from "../../../components/AdminNav/AdminNav";

export default function Adminusercontrol() {
  const { user: currentUser } = useUser();
  const [users, setUsers] = useState([]);
  const [unactivatedUsers, setUnactivatedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;

  // Fetch all users
  const fetchUsers = useCallback(() => {
    const token = localStorage.getItem('token');
    fetch(`${apiUrl}/users`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      },
      credentials: 'include'
    })
      .then((res) => res.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      });
  }, [apiUrl]);

  // Fetch unactivated users
  const fetchUnactivatedUsers = useCallback(() => {
    const token = localStorage.getItem('token');
    fetch(`${apiUrl}/users/unactivated`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      },
      credentials: 'include'
    })
      .then((res) => res.json())
      .then((data) => {
        setUnactivatedUsers(data);
      });
  }, [apiUrl]);

  useEffect(() => {
    fetchUsers();
    fetchUnactivatedUsers();
  }, [fetchUsers, fetchUnactivatedUsers]);

  const handleDelete = async (id) => {
    if (currentUser && currentUser.id === id) return; // Prevent self-delete
    const token = localStorage.getItem('token');
    await fetch(`${apiUrl}/users/${id}`, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      },
      credentials: 'include'
    });
    fetchUsers();
    fetchUnactivatedUsers();
  };

  const handleActivate = async (id) => {
    const token = localStorage.getItem('token');
    await fetch(`${apiUrl}/users/${id}/activate`, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      },
      credentials: "include",
    });
    fetchUsers();
    fetchUnactivatedUsers();
  };

  return (
    <div>
      <AdminNav />
      <div className="admin-container">
        <h2>Aktiválásra váró felhasználók</h2>
        <table className="admin-user-table">
          <thead>
            <tr>
              <th>Felhasználónév</th>
              <th>Aktiválás</th>
            </tr>
          </thead>
          <tbody>
            {unactivatedUsers.map((user) => (
              <tr key={user.id}>
                <td>{user.username}</td>
                <td>
                  <button onClick={() => handleActivate(user.id)} className="activate-btn">Aktiválás</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <h2>Felhasználók kezelése</h2>
        {loading ? (
          <div>Betöltés...</div>
        ) : (
          <table className="admin-user-table">
            <thead>
              <tr>
                <th>Név</th>
                <th>Admin</th>
                <th>Aktivált</th>
                <th>Törlés</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.is_admin ? "Igen" : "Nem"}</td>
                  <td>{user.is_activated ? "Igen" : "Nem"}</td>
                  <td>
                    {!(currentUser && currentUser.id === user.id) && (
                      <button
                        onClick={() => handleDelete(user.id)}
                        className="delete-btn"
                      >Törlés</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
